// Waste & Meals — draft persistence and the idempotency key.
//
// CLIENT_REQUEST_ID LIFECYCLE (defect C, written down because the unique
// index is only correct under this rule):
//   * minted when the form is opened, and again after every successful save;
//   * reused ONLY for an automatic retry of a byte-identical payload after a
//     timeout or a network failure;
//   * any user edit after a failure mints a new one.
//
// The draft persists per user + branch + date + type until the save succeeds,
// so a dropped connection on a phone in a kitchen never loses typed lines.

const PREFIX = "wm_draft";

export function newCrid() {
    if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
    return `wm-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function draftKey({ userId, branchId, date, type, kind }) {
    return [PREFIX, kind || "sheet", userId || "anon", branchId || "-", date || "-", type || "-"].join(":");
}

export function loadDraft(key) {
    try {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function saveDraft(key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch {
        /* a full quota must never break the form */
    }
}

export function clearDraft(key) {
    try {
        localStorage.removeItem(key);
    } catch {
        /* ignore */
    }
}
